module.exports = __webpack_public_path__ + "img/C102.7f195e6b.png";